import immutablePersistenceTransform from 'Services/ImmutablePersistenceTransform'
import storage from 'redux-persist/lib/storage'

// More info here:
// https://shift.infinite.red/shipping-persistant-reducers-7341691232b1
const REDUX_PERSIST = {
  active: true,
  reducerVersion: '1.0',
  storeConfig: {
    key: 'primary',
    storage,
    // blacklist: [],
    whitelist: [
      'auth'
    ],
    transforms: [immutablePersistenceTransform]
  }
}

export default REDUX_PERSIST



// WEBPACK FOOTER //
// ./src/Config/ReduxPersist.js